// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes jelloShake {
    0%, 100% {
      transform: scale(1, 1);
    }
    30% {
      transform: scale(1.25, 0.75);
    }
    40% {
      transform: scale(0.75, 1.25);
    }
    50% {
      transform: scale(1.15, 0.85);
    }
    65% {
      transform: scale(0.95, 1.05);
    }
    75% {
      transform: scale(1.05, 0.95);
    }
  }

/* Android-like Spinner animation */
@keyframes androidSpinner {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(180deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  
  @keyframes androidSpinnerColor {
    0% {
      border-top-color: #ffcb00; /* Yellow */
    }
  }
  
  .android-spinner {
    border: 4px solid transparent; /* Transparent border */
    border-radius: 50%; /* Make it circular */
    border-top: 4px solid #ffcb00; /* Top color will animate */
    width: 50px;
    height: 50px;
    animation: androidSpinner 1s linear infinite, androidSpinnerColor 4s linear infinite; /* Rotate and color change animations */
    margin: 20px auto; /* Center the spinner */
  }

.popular-page {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px 20px 20px 60px;
    display: flex;
    background-color: #013020;
    gap: 40px;
}


/* Sidebar and general layout */
.popular-page h2 {
    text-align: left;
    color: #ffcc00;
    margin-bottom: 20px;
}

.popular-page .sidebar {
    width: 350px;
    border: 1px solid #ddd;
    background-color: #265d38;
    padding: 20px;
    border-radius: 5px;
    margin-left: 50px;
    align-self: flex-start;
}

.popular-page .content {
    flex-grow: 1;
    padding-left: 0px;
    display: flex;
    flex-direction: column;
}

/* Card-specific styles */
.card-container {
    margin-bottom: 20px; /* Increased margin for better spacing */
    padding: 20px; /* Increased padding to make cards bigger */
    border-radius: 8px; /* Slightly larger border radius */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Larger shadow for emphasis */
    background-color: #265d38;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    width: 100%;
    font-size: 1.1rem; /* Increased font size for better readability */
    transition: all 0.3s ease;
}

.card-container:active {
    animation: jelloShake 0.9s both;
}

.card-container:hover {
    transform: scale(1.02);
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.card-content {
    margin-top: 10px;
    text-align: left; /* Ensure text is left-aligned */
    color: #ffcb00;
    width: 100%; /* Ensure it takes the full width */
    display: flex; /* Make it a flex container */
    justify-content: flex-start; /* Align items to the left */
    padding-left: 0; /* Remove any unintended padding */
}

/* Specific styles for each text element in the card */
.card-rank {
    font-weight: bold;
    margin-right: 10px;
    color: #ffcb00;
    font-size: 1.5rem;
}

.card-code {
    font-weight: bold;
    margin-right: 10px;
    color: #ffffff;
    font-size: 1.5rem;
}



.card-enrollment {
    font-style: italic;
    margin-left: 0;
    color: #ffffff;
    align-self: flex-end;
}

.card-name {
    flex-grow: 1;
    color: #ffffff;
    font-size: 1.1rem;
}

.card-department {
    color: #ffffff;
    padding-left: 0px;
    text-align: left;
    width: 100%;
    font-size: 1.1rem;
}

/* The rest of your CSS remains the same */
.popular-page .sidebar button {
    display: block;
    width: 100%;
    padding: 10px;
    margin-bottom: 20px;
    background-color: #ffffff;
    border: 1px solid #ddd;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s;
    text-align: left;
    font-size: 1rem;
}

.popular-page .sidebar button:hover:not(.active) {
    background-color: #e0e0e0;
}

.popular-page .sidebar button.active {
    background-color: #265d38;
    color: white;
}

.popular-page .selectors {
    display: flex;
    justify-content: flex-start;
    margin-bottom: -10px;
}

.popular-page .custom-select {
    position: relative;
    width: 120px;
    margin-right: 20px;
    z-index: 1; 
}

.popular-page .custom-select label {
    position: absolute;
    left: 10px;
    top: -10px;
    background-color: #013020;
    padding: 0 5px;
    font-size: 13px;
    font-weight: bold;
    color: #ffcb00;
    transition: all 0.3s ease;
    z-index: 2;
}

.popular-page .results .department {
    color: #ffcb00;
    display: block;
    margin-top: 5px;
    margin-left: 0; /* Ensure no unintended left margin */
    padding-left: 5px; /* Add a slight left padding for better alignment */
    text-align: left; /* Keep text aligned to the left */
}

.popular-page .custom-select-selected {
    background-color: #013020;
    border: 2px solid #265d38;
    padding: 12px 12px 8px;
    border-radius: 5px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: all 0.3s ease;
    position: relative;
    z-index: 1;
    color: #ffcb00;
}

.popular-page .custom-select-selected:hover {
    border-color: #ffcb00;
}

.popular-page .custom-select-selected.active {
    border-color: #ffcb00;
}

.popular-page .custom-select-selected::after {
    content: '▼';
    font-size: 0.6em;
    margin-bottom: 3px;
    margin-left: 5px;
}

.popular-page .custom-select-options {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background-color: #013020;
    border: 2px solid #265d38;
    border-top: none;
    border-radius: 0 0 5px 5px;
    z-index: 2;
    max-height: 200px;
    overflow-y: auto;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.popular-page .custom-select-options::-webkit-scrollbar {
    width: 8px;
}

.popular-page .custom-select-options::-webkit-scrollbar-track {
    background-color: #013020;
}

.popular-page .custom-select-options::-webkit-scrollbar-thumb {
    background-color: #265d38;
    border-radius: 4px;
}

.popular-page .custom-select-option {
    padding: 8px 12px;
    cursor: pointer;
    transition: background-color 0.2s;
    color: #ffcb00;
}

.popular-page .custom-select-option:hover {
    background-color: #265d38;
}

.popular-page .results {
    display: flex;
    flex-direction: column;
}

.popular-page .results-header {
    margin-bottom: 20px;
}

.popular-page .results ul {
    list-style-type: none;
    padding: 0;
}

.popular-page .results li {
    width: 100%;
    margin-bottom: 10px;
    padding: 10px;
    border-radius: 5px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    background-color: #265d38;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
}

.popular-page .results .rank {
    font-weight: bold;
    margin-right: 10px;
    min-width: 30px;
    color: #ffcb00;
    display: inline-block; 
}

.popular-page .results .code {
    font-weight: bold;
    margin-right: 10px;
    color: #ffcb00;
}

.popular-page .results .name {
    flex-grow: 1;
    color: #ffcb00;
}

.popular-page .results .enrollment {
    font-style: italic;
    margin-left: 0;
    color: #ffcb00;
    align-self: flex-end;
}

.popular-page .menu-toggle {
    display: none;
    cursor: pointer;
    padding: 10px;
    background-color: #f0f0f0;
    border-radius: 5px;
    margin-bottom: 20px;
}

.popular-page .top-enroll{
    color: #ffcc00;
    margin-bottom: 20px;
    font-size: 1.5rem;
    font-weight: bold;
}


.mobile-dropdown {
    width: 100%;
    margin-bottom: 20px;
    position: relative;
    z-index: 1000;
  }
  
  .mobile-dropdown-header {
    background-color: #265d38;
    color: #ffcb00;
    padding: 15px;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    border: 2px solid #ffcb00;
  }
  
  .mobile-dropdown-header.active {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  
  .dropdown-arrow {
    font-size: 0.8em;
    transition: transform 0.3s ease;
  }
  
  .dropdown-arrow.open {
    transform: rotate(180deg);
  }
  
  .mobile-dropdown-content {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background-color: #265d38;
    border: 2px solid #ffcb00;
    border-top: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
  
  .mobile-dropdown-item {
    padding: 15px;
    color: #ffcb00;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .mobile-dropdown-item:hover {
    background-color: #013020;
  }
  
  .mobile-dropdown-item.active {
    background-color: #013020;
  }

  @media (max-width: 768px) {
    .popular-page {
        flex-direction: column;
        padding: 20px;
    }

    .popular-page .selectors {
        flex-direction: column;
        gap: 15px;
        margin-bottom: 20px;
    }

    .popular-page .custom-select {
        width: 100%;
        margin-bottom: 0;
        margin-right: 0;
    }

    /* Ensure the dropdowns stack correctly without overlapping */
    .popular-page .custom-select-options {
        position: absolute;
        z-index: 999;
    }

    .popular-page .sidebar {
        display: none;
    }

    .popular-page .content {
        padding-left: 0;
        width: 100%;
    }

    /* Remove old menu toggle */
    .popular-page .menu-toggle {
        display: none;
    }

    /* Card adjustments for mobile */
    .card-container {
        padding: 15px;
        margin-bottom: 15px;
    }

    .card-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }

    .card-enrollment {
        align-self: flex-start;
    }

    .card-content {
        margin-top: 8px;
    }

    .card-rank {
        font-size: 1.2rem;
    }

    .card-code {
        font-size: 1.2rem;
    }

    /* Mobile dropdown specific styles */
    .mobile-dropdown {
        width: 100%;
        margin-bottom: 20px;
    }

    .mobile-dropdown-header {
        padding: 12px 15px;
    }

    .mobile-dropdown-item {
        padding: 12px 15px;
    }

    /* Top enroll text adjustment */
    .popular-page .top-enroll {
        font-size: 1.3rem;
        margin-bottom: 15px;
    }

    /* Results container adjustment */
    .popular-page .results {
        margin-top: 10px;
    }

    /* Custom select adjustments */
    .popular-page .custom-select-selected {
        padding: 10px 12px 8px;
    }

    /* Spinner adjustment */
    .android-spinner {
        width: 40px;
        height: 40px;
        margin: 15px auto;
    }

    /* Error message adjustment */
    .error {
        padding: 10px;
        margin: 10px 0;
        text-align: center;
    }

    /* List adjustments */
    .popular-page .results ul {
        margin: 0;
        padding: 0;
    }

    .popular-page .results li:last-child {
        margin-bottom: 0;
    }
}

/* Additional breakpoint for very small devices */
@media (max-width: 380px) {
    .popular-page {
        padding: 15px;
    }

    .card-container {
        padding: 12px;
    }

    .card-rank, .card-code {
        font-size: 1.1rem;
    }

    .card-name, .card-department {
        font-size: 1rem;
    }

    .popular-page .top-enroll {
        font-size: 1.2rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/PopularPage.css"],"names":[],"mappings":"AAAA;IACI;MACE,sBAAsB;IACxB;IACA;MACE,4BAA4B;IAC9B;IACA;MACE,4BAA4B;IAC9B;IACA;MACE,4BAA4B;IAC9B;IACA;MACE,4BAA4B;IAC9B;IACA;MACE,4BAA4B;IAC9B;EACF;;AAEF,mCAAmC;AACnC;IACI;MACE,uBAAuB;IACzB;IACA;MACE,yBAAyB;IAC3B;IACA;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE;MACE,yBAAyB,EAAE,WAAW;IACxC;EACF;;EAEA;IACE,6BAA6B,EAAE,uBAAuB;IACtD,kBAAkB,EAAE,qBAAqB;IACzC,6BAA6B,EAAE,2BAA2B;IAC1D,WAAW;IACX,YAAY;IACZ,oFAAoF,EAAE,uCAAuC;IAC7H,iBAAiB,EAAE,uBAAuB;EAC5C;;AAEF;IACI,iBAAiB;IACjB,cAAc;IACd,4BAA4B;IAC5B,aAAa;IACb,yBAAyB;IACzB,SAAS;AACb;;;AAGA,+BAA+B;AAC/B;IACI,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,sBAAsB;AAC1B;;AAEA,yBAAyB;AACzB;IACI,mBAAmB,EAAE,wCAAwC;IAC7D,aAAa,EAAE,2CAA2C;IAC1D,kBAAkB,EAAE,kCAAkC;IACtD,wCAAwC,EAAE,+BAA+B;IACzE,yBAAyB;IACzB,aAAa;IACb,8BAA8B;IAC9B,sBAAsB;IACtB,WAAW;IACX,iBAAiB,EAAE,+CAA+C;IAClE,yBAAyB;AAC7B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,gBAAgB,EAAE,gCAAgC;IAClD,cAAc;IACd,WAAW,EAAE,mCAAmC;IAChD,aAAa,EAAE,6BAA6B;IAC5C,2BAA2B,EAAE,4BAA4B;IACzD,eAAe,EAAE,kCAAkC;AACvD;;AAEA,sDAAsD;AACtD;IACI,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;AACrB;;;;AAIA;IACI,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,iBAAiB;AACrB;;AAEA,0CAA0C;AAC1C;IACI,cAAc;IACd,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,iCAAiC;IACjC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,cAAc;IACd,cAAc;IACd,eAAe;IACf,cAAc,EAAE,qCAAqC;IACrD,iBAAiB,EAAE,mDAAmD;IACtE,gBAAgB,EAAE,kCAAkC;AACxD;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB;IAChB,0BAA0B;IAC1B,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,iCAAiC;IACjC,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,qCAAqC;IACrC,yBAAyB;IACzB,aAAa;IACb,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;AACrB;;;AAGA;IACI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;;EAEA;IACE,gBAAgB;IAChB,+BAA+B;EACjC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB;IAChB,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,aAAa;IACb,cAAc;IACd,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE;QACI,sBAAsB;QACtB,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,eAAe;IACnB;;IAEA,6DAA6D;IAC7D;QACI,kBAAkB;QAClB,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA,2BAA2B;IAC3B;QACI,aAAa;IACjB;;IAEA,gCAAgC;IAChC;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA,oCAAoC;IACpC;QACI,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA,+BAA+B;IAC/B;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA,iCAAiC;IACjC;QACI,gBAAgB;IACpB;;IAEA,8BAA8B;IAC9B;QACI,sBAAsB;IAC1B;;IAEA,uBAAuB;IACvB;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;;IAEA,6BAA6B;IAC7B;QACI,aAAa;QACb,cAAc;QACd,kBAAkB;IACtB;;IAEA,qBAAqB;IACrB;QACI,SAAS;QACT,UAAU;IACd;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA,iDAAiD;AACjD;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":["@keyframes jelloShake {\n    0%, 100% {\n      transform: scale(1, 1);\n    }\n    30% {\n      transform: scale(1.25, 0.75);\n    }\n    40% {\n      transform: scale(0.75, 1.25);\n    }\n    50% {\n      transform: scale(1.15, 0.85);\n    }\n    65% {\n      transform: scale(0.95, 1.05);\n    }\n    75% {\n      transform: scale(1.05, 0.95);\n    }\n  }\n\n/* Android-like Spinner animation */\n@keyframes androidSpinner {\n    0% {\n      transform: rotate(0deg);\n    }\n    50% {\n      transform: rotate(180deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n  \n  @keyframes androidSpinnerColor {\n    0% {\n      border-top-color: #ffcb00; /* Yellow */\n    }\n  }\n  \n  .android-spinner {\n    border: 4px solid transparent; /* Transparent border */\n    border-radius: 50%; /* Make it circular */\n    border-top: 4px solid #ffcb00; /* Top color will animate */\n    width: 50px;\n    height: 50px;\n    animation: androidSpinner 1s linear infinite, androidSpinnerColor 4s linear infinite; /* Rotate and color change animations */\n    margin: 20px auto; /* Center the spinner */\n  }\n\n.popular-page {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 20px 20px 20px 60px;\n    display: flex;\n    background-color: #013020;\n    gap: 40px;\n}\n\n\n/* Sidebar and general layout */\n.popular-page h2 {\n    text-align: left;\n    color: #ffcc00;\n    margin-bottom: 20px;\n}\n\n.popular-page .sidebar {\n    width: 350px;\n    border: 1px solid #ddd;\n    background-color: #265d38;\n    padding: 20px;\n    border-radius: 5px;\n    margin-left: 50px;\n    align-self: flex-start;\n}\n\n.popular-page .content {\n    flex-grow: 1;\n    padding-left: 0px;\n    display: flex;\n    flex-direction: column;\n}\n\n/* Card-specific styles */\n.card-container {\n    margin-bottom: 20px; /* Increased margin for better spacing */\n    padding: 20px; /* Increased padding to make cards bigger */\n    border-radius: 8px; /* Slightly larger border radius */\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Larger shadow for emphasis */\n    background-color: #265d38;\n    display: flex;\n    justify-content: space-between;\n    flex-direction: column;\n    width: 100%;\n    font-size: 1.1rem; /* Increased font size for better readability */\n    transition: all 0.3s ease;\n}\n\n.card-container:active {\n    animation: jelloShake 0.9s both;\n}\n\n.card-container:hover {\n    transform: scale(1.02);\n}\n\n.card-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n}\n\n.card-content {\n    margin-top: 10px;\n    text-align: left; /* Ensure text is left-aligned */\n    color: #ffcb00;\n    width: 100%; /* Ensure it takes the full width */\n    display: flex; /* Make it a flex container */\n    justify-content: flex-start; /* Align items to the left */\n    padding-left: 0; /* Remove any unintended padding */\n}\n\n/* Specific styles for each text element in the card */\n.card-rank {\n    font-weight: bold;\n    margin-right: 10px;\n    color: #ffcb00;\n    font-size: 1.5rem;\n}\n\n.card-code {\n    font-weight: bold;\n    margin-right: 10px;\n    color: #ffffff;\n    font-size: 1.5rem;\n}\n\n\n\n.card-enrollment {\n    font-style: italic;\n    margin-left: 0;\n    color: #ffffff;\n    align-self: flex-end;\n}\n\n.card-name {\n    flex-grow: 1;\n    color: #ffffff;\n    font-size: 1.1rem;\n}\n\n.card-department {\n    color: #ffffff;\n    padding-left: 0px;\n    text-align: left;\n    width: 100%;\n    font-size: 1.1rem;\n}\n\n/* The rest of your CSS remains the same */\n.popular-page .sidebar button {\n    display: block;\n    width: 100%;\n    padding: 10px;\n    margin-bottom: 20px;\n    background-color: #ffffff;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n    text-align: left;\n    font-size: 1rem;\n}\n\n.popular-page .sidebar button:hover:not(.active) {\n    background-color: #e0e0e0;\n}\n\n.popular-page .sidebar button.active {\n    background-color: #265d38;\n    color: white;\n}\n\n.popular-page .selectors {\n    display: flex;\n    justify-content: flex-start;\n    margin-bottom: -10px;\n}\n\n.popular-page .custom-select {\n    position: relative;\n    width: 120px;\n    margin-right: 20px;\n    z-index: 1; \n}\n\n.popular-page .custom-select label {\n    position: absolute;\n    left: 10px;\n    top: -10px;\n    background-color: #013020;\n    padding: 0 5px;\n    font-size: 13px;\n    font-weight: bold;\n    color: #ffcb00;\n    transition: all 0.3s ease;\n    z-index: 2;\n}\n\n.popular-page .results .department {\n    color: #ffcb00;\n    display: block;\n    margin-top: 5px;\n    margin-left: 0; /* Ensure no unintended left margin */\n    padding-left: 5px; /* Add a slight left padding for better alignment */\n    text-align: left; /* Keep text aligned to the left */\n}\n\n.popular-page .custom-select-selected {\n    background-color: #013020;\n    border: 2px solid #265d38;\n    padding: 12px 12px 8px;\n    border-radius: 5px;\n    cursor: pointer;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    transition: all 0.3s ease;\n    position: relative;\n    z-index: 1;\n    color: #ffcb00;\n}\n\n.popular-page .custom-select-selected:hover {\n    border-color: #ffcb00;\n}\n\n.popular-page .custom-select-selected.active {\n    border-color: #ffcb00;\n}\n\n.popular-page .custom-select-selected::after {\n    content: '▼';\n    font-size: 0.6em;\n    margin-bottom: 3px;\n    margin-left: 5px;\n}\n\n.popular-page .custom-select-options {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    background-color: #013020;\n    border: 2px solid #265d38;\n    border-top: none;\n    border-radius: 0 0 5px 5px;\n    z-index: 2;\n    max-height: 200px;\n    overflow-y: auto;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.popular-page .custom-select-options::-webkit-scrollbar {\n    width: 8px;\n}\n\n.popular-page .custom-select-options::-webkit-scrollbar-track {\n    background-color: #013020;\n}\n\n.popular-page .custom-select-options::-webkit-scrollbar-thumb {\n    background-color: #265d38;\n    border-radius: 4px;\n}\n\n.popular-page .custom-select-option {\n    padding: 8px 12px;\n    cursor: pointer;\n    transition: background-color 0.2s;\n    color: #ffcb00;\n}\n\n.popular-page .custom-select-option:hover {\n    background-color: #265d38;\n}\n\n.popular-page .results {\n    display: flex;\n    flex-direction: column;\n}\n\n.popular-page .results-header {\n    margin-bottom: 20px;\n}\n\n.popular-page .results ul {\n    list-style-type: none;\n    padding: 0;\n}\n\n.popular-page .results li {\n    width: 100%;\n    margin-bottom: 10px;\n    padding: 10px;\n    border-radius: 5px;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n    background-color: #265d38;\n    display: flex;\n    justify-content: space-between;\n    flex-direction: column;\n}\n\n.popular-page .results .rank {\n    font-weight: bold;\n    margin-right: 10px;\n    min-width: 30px;\n    color: #ffcb00;\n    display: inline-block; \n}\n\n.popular-page .results .code {\n    font-weight: bold;\n    margin-right: 10px;\n    color: #ffcb00;\n}\n\n.popular-page .results .name {\n    flex-grow: 1;\n    color: #ffcb00;\n}\n\n.popular-page .results .enrollment {\n    font-style: italic;\n    margin-left: 0;\n    color: #ffcb00;\n    align-self: flex-end;\n}\n\n.popular-page .menu-toggle {\n    display: none;\n    cursor: pointer;\n    padding: 10px;\n    background-color: #f0f0f0;\n    border-radius: 5px;\n    margin-bottom: 20px;\n}\n\n.popular-page .top-enroll{\n    color: #ffcc00;\n    margin-bottom: 20px;\n    font-size: 1.5rem;\n    font-weight: bold;\n}\n\n\n.mobile-dropdown {\n    width: 100%;\n    margin-bottom: 20px;\n    position: relative;\n    z-index: 1000;\n  }\n  \n  .mobile-dropdown-header {\n    background-color: #265d38;\n    color: #ffcb00;\n    padding: 15px;\n    border-radius: 5px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    cursor: pointer;\n    border: 2px solid #ffcb00;\n  }\n  \n  .mobile-dropdown-header.active {\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  \n  .dropdown-arrow {\n    font-size: 0.8em;\n    transition: transform 0.3s ease;\n  }\n  \n  .dropdown-arrow.open {\n    transform: rotate(180deg);\n  }\n  \n  .mobile-dropdown-content {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    background-color: #265d38;\n    border: 2px solid #ffcb00;\n    border-top: none;\n    border-bottom-left-radius: 5px;\n    border-bottom-right-radius: 5px;\n  }\n  \n  .mobile-dropdown-item {\n    padding: 15px;\n    color: #ffcb00;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n  }\n  \n  .mobile-dropdown-item:hover {\n    background-color: #013020;\n  }\n  \n  .mobile-dropdown-item.active {\n    background-color: #013020;\n  }\n\n  @media (max-width: 768px) {\n    .popular-page {\n        flex-direction: column;\n        padding: 20px;\n    }\n\n    .popular-page .selectors {\n        flex-direction: column;\n        gap: 15px;\n        margin-bottom: 20px;\n    }\n\n    .popular-page .custom-select {\n        width: 100%;\n        margin-bottom: 0;\n        margin-right: 0;\n    }\n\n    /* Ensure the dropdowns stack correctly without overlapping */\n    .popular-page .custom-select-options {\n        position: absolute;\n        z-index: 999;\n    }\n\n    .popular-page .sidebar {\n        display: none;\n    }\n\n    .popular-page .content {\n        padding-left: 0;\n        width: 100%;\n    }\n\n    /* Remove old menu toggle */\n    .popular-page .menu-toggle {\n        display: none;\n    }\n\n    /* Card adjustments for mobile */\n    .card-container {\n        padding: 15px;\n        margin-bottom: 15px;\n    }\n\n    .card-header {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 10px;\n    }\n\n    .card-enrollment {\n        align-self: flex-start;\n    }\n\n    .card-content {\n        margin-top: 8px;\n    }\n\n    .card-rank {\n        font-size: 1.2rem;\n    }\n\n    .card-code {\n        font-size: 1.2rem;\n    }\n\n    /* Mobile dropdown specific styles */\n    .mobile-dropdown {\n        width: 100%;\n        margin-bottom: 20px;\n    }\n\n    .mobile-dropdown-header {\n        padding: 12px 15px;\n    }\n\n    .mobile-dropdown-item {\n        padding: 12px 15px;\n    }\n\n    /* Top enroll text adjustment */\n    .popular-page .top-enroll {\n        font-size: 1.3rem;\n        margin-bottom: 15px;\n    }\n\n    /* Results container adjustment */\n    .popular-page .results {\n        margin-top: 10px;\n    }\n\n    /* Custom select adjustments */\n    .popular-page .custom-select-selected {\n        padding: 10px 12px 8px;\n    }\n\n    /* Spinner adjustment */\n    .android-spinner {\n        width: 40px;\n        height: 40px;\n        margin: 15px auto;\n    }\n\n    /* Error message adjustment */\n    .error {\n        padding: 10px;\n        margin: 10px 0;\n        text-align: center;\n    }\n\n    /* List adjustments */\n    .popular-page .results ul {\n        margin: 0;\n        padding: 0;\n    }\n\n    .popular-page .results li:last-child {\n        margin-bottom: 0;\n    }\n}\n\n/* Additional breakpoint for very small devices */\n@media (max-width: 380px) {\n    .popular-page {\n        padding: 15px;\n    }\n\n    .card-container {\n        padding: 12px;\n    }\n\n    .card-rank, .card-code {\n        font-size: 1.1rem;\n    }\n\n    .card-name, .card-department {\n        font-size: 1rem;\n    }\n\n    .popular-page .top-enroll {\n        font-size: 1.2rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
